const LONG_FMT = new Intl.DateTimeFormat('en', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

const SHORT_FMT = new Intl.DateTimeFormat('en', {
  day: 'numeric',
  month: 'short',
});

export function formatEventDate(iso: string | null | undefined): string {
  if (!iso) return 'Date unknown';
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  const now = new Date();
  return d.getFullYear() === now.getFullYear()
    ? SHORT_FMT.format(d)
    : LONG_FMT.format(d);
}

export function formatLongDate(iso: string | null | undefined): string {
  if (!iso) return 'Date unknown';
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return LONG_FMT.format(d);
}

export function calculateAge(dob: string | null | undefined): number | null {
  if (!dob) return null;
  const d = new Date(`${dob}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  let years = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) years -= 1;
  return years >= 0 ? years : null;
}

export function calculateAgeVerbose(dob: string | null | undefined): string | null {
  if (!dob) return null;
  const d = new Date(`${dob}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  let years = now.getFullYear() - d.getFullYear();
  let months = now.getMonth() - d.getMonth();
  if (now.getDate() < d.getDate()) months -= 1;
  if (months < 0) { years -= 1; months += 12; }
  if (years < 0) return null;
  if (years === 0) return months <= 1 ? `${months} mo` : `${months} mo`;
  if (months === 0) return `${years} yr${years !== 1 ? 's' : ''}`;
  return `${years} yr${years !== 1 ? 's' : ''} ${months} mo`;
}

const MONTH_FMT = new Intl.DateTimeFormat('en', {
  month: 'long',
  year: 'numeric',
});

export function formatMonthKey(iso: string | null | undefined): string {
  if (!iso) return 'Undated';
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return 'Undated';
  return MONTH_FMT.format(d);
}

export function formatRelative(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const days = Math.floor(
    (start.getTime() - d.getTime()) / (1000 * 60 * 60 * 24),
  );
  if (days < 0) return formatEventDate(iso);
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days}d ago`;
  if (days < 30) return `${Math.floor(days / 7)}w ago`;
  if (days < 365) return `${Math.floor(days / 30)}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}
